// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/calculate2.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.intro_section .container_slider img {
  max-width: 100%;
}

.container_job {
  display: flex;
  justify-content: center;
}
@media screen and (min-width: 1200px) {
  .container_job .wrapper_job {
    max-width: 1200px;
  }
}
@media screen and (max-width: 480px) {
  .container_job .wrapper_job {
    margin-top: 40px;
    max-width: 400px;
  }
}
.container_job .wrapper_job .title_job h3 {
  text-align: center;
  color: #323232;
  font-family: "Century Gothic";
  font-weight: 300;
  font-size: 3em;
  line-height: 4rem;
}
@media screen and (max-width: 991px) {
  .container_job .wrapper_job .title_job h3 {
    margin: 0 auto;
    max-width: 720px;
  }
}
@media screen and (max-width: 640px) {
  .container_job .wrapper_job .title_job h3 {
    max-width: 580px;
  }
}
@media screen and (max-width: 480px) {
  .container_job .wrapper_job .title_job h3 {
    padding: 0 20px;
    font-size: 1.56rem;
    line-height: 1.2em;
  }
}
.container_job .wrapper_job .content_job {
  display: flex;
  flex-direction: row;
  padding: 0 15px;
}
@media screen and (max-width: 991px) {
  .container_job .wrapper_job .content_job {
    flex-direction: column;
  }
}
.container_job .wrapper_job .content_job .description_job {
  color: rgb(49, 49, 49);
  font-family: "Roboto-Light";
  font-size: 17px;
  line-height: 1.3em;
  text-align: left;
}
@media screen and (max-width: 991px) {
  .container_job .wrapper_job .content_job .description_job {
    margin: 0 60px;
    order: 2;
  }
}
@media screen and (max-width: 991px) {
  .container_job .wrapper_job .content_job .description_job {
    margin: 0 10px;
  }
}
@media screen and (max-width: 640px) {
  .container_job .wrapper_job .content_job .description_job {
    margin: 0 auto;
    padding: 0 20px;
    max-width: 480px;
  }
}
.container_job .wrapper_job .content_job .description_job .control_link {
  text-align: left;
}
@media screen and (max-width: 991px) {
  .container_job .wrapper_job .content_job .description_job .control_link {
    margin: 30px 0;
    text-align: center;
  }
}
@media screen and (max-width: 991px) {
  .container_job .wrapper_job .content_job .image_job {
    text-align: center;
    order: 1;
  }
}
@media screen and (max-width: 480px) {
  .container_job .wrapper_job .content_job .image_job img {
    max-width: 100%;
    height: auto;
  }
}

.calculator {
  display: flex;
  justify-content: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
}
@media screen and (min-width: 1200px) {
  .calculator .container_calculator {
    width: 1200px;
  }
}
.calculator .container_calculator h3 {
  padding: 0 120px;
  text-align: center;
  color: #323232;
  font-family: "Century Gothic";
  font-weight: 300;
  font-size: 2.4rem;
  line-height: 3rem;
}
@media screen and (max-width: 480px) {
  .calculator .container_calculator h3 {
    padding: 0 20px;
    font-size: 1.56rem;
    line-height: 1.2em;
  }
}

.foto_studio .container_foto_studio {
  max-width: 800px;
  margin: 30px auto;
}
.foto_studio .container_foto_studio h3 {
  text-align: center;
  color: #323232;
  font-family: "Century Gothic";
  font-weight: 300;
  font-size: 3.2rem;
  line-height: 4rem;
}
@media screen and (max-width: 480px) {
  .foto_studio .container_foto_studio h3 {
    padding: 0 20px;
    font-size: 1.56rem;
    line-height: 1.2em;
  }
}
.foto_studio .container_foto_studio .description_foto_studio {
  color: rgb(129, 129, 129);
  font-family: "Roboto-Light";
  font-weight: 300;
  font-size: 17px;
}
@media screen and (max-width: 480px) {
  .foto_studio .container_foto_studio .description_foto_studio {
    padding: 0 20px;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/Home.scss"],"names":[],"mappings":"AAEQ;EACI,eAAA;AADZ;;AAMA;EACI,aAAA;EAEA,uBAAA;AAJJ;AAOQ;EADJ;IAEQ,iBAAA;EAJV;AACF;AAMQ;EALJ;IAMQ,gBAAA;IACA,gBAAA;EAHV;AACF;AAQY;EACI,kBAAA;EACA,cAAA;EACA,6BAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AANhB;AAQgB;EARJ;IASQ,cAAA;IACA,gBAAA;EALlB;AACF;AAOgB;EAbJ;IAcQ,gBAAA;EAJlB;AACF;AAMgB;EAjBJ;IAkBQ,eAAA;IACA,kBAAA;IACA,kBAAA;EAHlB;AACF;AAOQ;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AALZ;AAOY;EALJ;IAMQ,sBAAA;EAJd;AACF;AAMY;EACI,sBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAJhB;AAMgB;EAPJ;IAQQ,cAAA;IACA,QAAA;EAHlB;AACF;AAKgB;EAZJ;IAaQ,cAAA;EAFlB;AACF;AAIgB;EAhBJ;IAiBQ,cAAA;IACA,eAAA;IACA,gBAAA;EADlB;AACF;AAGgB;EACI,gBAAA;AADpB;AAGoB;EAHJ;IAIQ,cAAA;IACA,kBAAA;EAAtB;AACF;AAMgB;EAFJ;IAGQ,kBAAA;IACA,QAAA;EAHlB;AACF;AAMoB;EADJ;IAEQ,eAAA;IACA,YAAA;EAHtB;AACF;;AAUA;EACI,aAAA;EACA,uBAAA;EACA,yDAAA;EACA,sBAAA;AAPJ;AAUQ;EADJ;IAEQ,aAAA;EAPV;AACF;AASQ;EACI,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;EAEA,iBAAA;AARZ;AAUY;EAVJ;IAWQ,eAAA;IACA,kBAAA;IACA,kBAAA;EAPd;AACF;;AAaI;EACI,gBAAA;EACA,iBAAA;AAVR;AAYQ;EACI,kBAAA;EACA,cAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAVZ;AAYY;EARJ;IASQ,eAAA;IACA,kBAAA;IACA,kBAAA;EATd;AACF;AAYQ;EACI,yBAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;AAVZ;AAaY;EAPJ;IAQQ,eAAA;IACA,kBAAA;EAVd;AACF","sourcesContent":[".intro_section {\n    .container_slider {\n        img {\n            max-width: 100%;\n        }\n    }\n}\n\n.container_job {\n    display: flex;\n    // flex-direction: column;\n    justify-content: center;\n\n    .wrapper_job {\n        @media screen and (min-width: 1200px) {\n            max-width: 1200px;\n        }\n\n        @media screen and (max-width: 480px) {\n            margin-top: 40px;\n            max-width: 400px;\n        }\n\n        .title_job {\n\n            // word-wrap: break-word;\n            h3 {\n                text-align: center;\n                color: #323232;\n                font-family: \"Century Gothic\";\n                font-weight: 300;\n                font-size: 3em;\n                line-height: 4rem;\n\n                @media screen and (max-width: 991px) {\n                    margin: 0 auto;\n                    max-width: 720px;\n                }\n\n                @media screen and (max-width: 640px) {\n                    max-width: 580px;\n                }\n\n                @media screen and (max-width: 480px) {\n                    padding: 0 20px;\n                    font-size: 1.56rem;\n                    line-height: 1.2em;\n                }\n            }\n        }\n\n        .content_job {\n            display: flex;\n            flex-direction: row;\n            padding: 0 15px;\n\n            @media screen and (max-width: 991px) {\n                flex-direction: column;\n            }\n\n            .description_job {\n                color: rgb(49, 49, 49);\n                font-family: \"Roboto-Light\";\n                font-size: 17px;\n                line-height: 1.3em;\n                text-align: left;\n\n                @media screen and (max-width: 991px) {\n                    margin: 0 60px;\n                    order: 2;\n                }\n\n                @media screen and (max-width: 991px) {\n                    margin: 0 10px;\n                }\n\n                @media screen and (max-width: 640px) {\n                    margin: 0 auto;\n                    padding: 0 20px;\n                    max-width: 480px;\n                }\n\n                .control_link {\n                    text-align: left;\n\n                    @media screen and (max-width: 991px) {\n                        margin: 30px 0;\n                        text-align: center;\n                    }\n                }\n            }\n\n            .image_job {\n\n                @media screen and (max-width: 991px) {\n                    text-align: center;\n                    order: 1;\n                }\n\n                img {\n                    @media screen and (max-width: 480px) {\n                        max-width: 100%;\n                        height: auto;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.calculator {\n    display: flex;\n    justify-content: center;\n    background-image: url('../../../public/images/calculate2.webp');\n    background-size: cover;\n\n    .container_calculator {\n        @media screen and (min-width: 1200px) {\n            width: 1200px;\n        }\n\n        h3 {\n            padding: 0 120px;\n            text-align: center;\n            color: #323232;\n            font-family: \"Century Gothic\";\n            font-weight: 300;\n            font-size: 2.4rem;\n            // font-size: 2.4rem;\n            line-height: 3rem;\n\n            @media screen and (max-width: 480px) {\n                padding: 0 20px;\n                font-size: 1.56rem;\n                line-height: 1.2em;\n            }\n        }\n    }\n}\n\n.foto_studio {\n    .container_foto_studio {\n        max-width: 800px;\n        margin: 30px auto;\n\n        h3 {\n            text-align: center;\n            color: #323232;\n            font-family: \"Century Gothic\";\n            font-weight: 300;\n            font-size: 3.2rem;\n            line-height: 4rem;\n\n            @media screen and (max-width: 480px) {\n                padding: 0 20px;\n                font-size: 1.56rem;\n                line-height: 1.2em;\n            }\n        }\n\n        .description_foto_studio {\n            color: rgb(129, 129, 129);\n            font-family: \"Roboto-Light\";\n            font-weight: 300;\n            font-size: 17px;\n\n\n            @media screen and (max-width: 480px) {\n                padding: 0 20px;\n                text-align: center;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
